module.exports = __webpack_public_path__ + "static/media/Clay Folk-100.67eeac73.webp";